import * as angular from 'angular';
import { config } from 'angular/utils/config';
import { XmlUploader } from '../custom';

export interface ReverseAuctionResource
    extends ng.resource.IResourceClass<
            ng.resource.IResource<ManualReverseAuctionUploadDto>
        >,
        XmlUploader {
    generateXml: ng.resource.IResourceMethod<
        ng.resource.IResource<FallbackUploadResponseDto>
    >;
    uploadAsXML: ng.resource.IResourceMethod<
        ng.resource.IResource<FallbackUploadResponseDto>
    >;
    save: ng.resource.IResourceMethod<
        ng.resource.IResource<ManualReverseAuctionUploadDto>
    >;
}

function reverseAuctionResource(
    $resource: ng.resource.IResourceService
): ReverseAuctionResource {
    return <ReverseAuctionResource>$resource(
        config.monolithApi + '/reverse-auction/',
        {},
        {
            generateXml: {
                method: 'POST',
                url: config.monolithApi + '/reverse-auction/as-xml'
            },
            uploadAsXML: {
                method: 'POST',
                url: config.monolithApi + '/reverse-auction',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }
        }
    );
}

angular.module('app').factory('reverseAuctionResource', reverseAuctionResource);
